import React, { useState, useEffect, useContext } from "react";
import logo from '../assets/images/Dadi-logo.svg';
// import socialMedia from '../assets/images/social-media-icons.svg';
// import youtube from '../assets/images/youtube-icon.svg';
import youtube from '../assets/images/icons/YouTube-Logo.svg'

import footerWave from '../assets/images/footer-wave.svg';
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();


  const handelnavigation2 = () => {
    navigate("/login")
  }

  const navigateCPC = () => {
    
    const token = localStorage.getItem("token");
    let nav = "/cpc"
    if (!token) {
      nav = "/cpcregistration"
    }
    return nav
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3 mb-4 footer-section">
            <img src={logo} alt="DADI Logo" className="logo" />
            <p className="txt-22">
              Join our expert dermatopathologists as they walk through real-world biopsy cases,
              discuss differential diagnoses, and unravel fascinating diagnostic challenges.
            </p>
            <button className="btn-stroke-icon mt-5" onClick={(e) => handelnavigation2()}>
              <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>
              Join Us Now
            </button>
          </div>

          <div className="col-md-3 mb-4 footer-section office_address">
            <p className="txt-16">Office Address</p>
            <ul className="contact">
              <li>
                <span className="link-bullet material-symbols-outlined">location_on</span>
                <p className="address">Dermpath Academy And Diagnostics India Private Limited 242 F/f, Sfs, Yusuf Sarai, Near Indian Oil Building, Gulmohar Park, New Delhi, South Delhi- 110049, Delhi</p>
              </li>
              <li>
                <span className="link-bullet material-symbols-outlined">call</span>
                <p className="address">+91 76748 23911</p>
              </li>
              <li>
                <span className="link-bullet material-symbols-outlined">mail</span>
                <p className="address">admin@dermpathacademy.in</p>
              </li>
            </ul>
          </div>

          <div className="col-md-3 mb-4 d-grid justify-content-center footer-section">
            <p className="txt-16">Links</p>
            <ul className="contact">
              <li><Link to="/"><span className="link-bullet">›</span> Home</Link></li>
              <li><Link to="/diagnostics"><span className="link-bullet">›</span> Diagnostics</Link></li>
              <li><Link to="/learning"><span className="link-bullet">›</span> Learning Hub</Link></li>
              <li><Link to={navigateCPC()}><span className="link-bullet">›</span> CPC</Link></li>
              <li><Link to="/fellowship"><span className="link-bullet">›</span> Fellowship</Link></li>
              <li><Link to="/about"><span className="link-bullet">›</span> About</Link></li>
              <li><Link to="/contact"><span className="link-bullet">›</span> Contact</Link></li>
            </ul>
          </div>

          <div className="col-md-3 mb-4 footer-section">
            <p className="txt-16">Social Media</p>
            <div className="youtube-icon">
              <a
                href="https://youtube.com/playlist?list=PL1u1zcr-ZEXEStQwQaFdwhdDut6Y-b7NX&si=B0AKH6bO7d_UjH7h"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtube} alt="Social Media" />
              </a>
            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom text-center mt-4">
        <div className="container pb-0 d-flex align-items-center">
          <div className="legal-links d-flex">
            <p>
              Copyright © {new Date().getFullYear()} <strong>DADI</strong>. All rights reserved
            </p>
            {/* <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms of Use</Link> */}
          </div>
          <p className="brandName">
            Powered By <a target="_blank" href="https://www.sanchaninfo.com/" style={{ color: "#212529", fontWeight: "bold", textDecoration: "none" }} rel="noreferrer">Sanchan Info Solutions</a>
          </p>
        </div>
      </div>

      <img src={footerWave} className="footer-img" alt="Footer Decoration" />
    </footer>

  );
};

export default Footer;